import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 16c0-2.654.69-5.205 1.98-7.456.466-.81-.336-1.76-1.213-1.436A18.004 18.004 0 0 0 6 24c0 9.943 8.058 18 18 18a18.003 18.003 0 0 0 16.892-11.767c.323-.877-.626-1.679-1.436-1.213A14.927 14.927 0 0 1 32 31c-8.285 0-15-6.714-15-15Zm7 24c-8.837 0-16-7.162-16-16 0-5.843 3.16-11.09 8.048-13.89A16.977 16.977 0 0 0 15 16c0 9.39 7.61 17 17 17 2.039 0 4.026-.36 5.89-1.048A16.003 16.003 0 0 1 24 40Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Moon_svg__a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 35,
    height: 35
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 16c0-2.654.69-5.205 1.98-7.456.466-.81-.336-1.76-1.213-1.436A18.004 18.004 0 0 0 6 24c0 9.943 8.058 18 18 18a18.003 18.003 0 0 0 16.892-11.767c.323-.877-.626-1.679-1.436-1.213A14.927 14.927 0 0 1 32 31c-8.285 0-15-6.714-15-15Zm7 24c-8.837 0-16-7.162-16-16 0-5.843 3.16-11.09 8.048-13.89A16.977 16.977 0 0 0 15 16c0 9.39 7.61 17 17 17 2.039 0 4.026-.36 5.89-1.048A16.003 16.003 0 0 1 24 40Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Moon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h48v48H0z"
  })));
};

var SvgMoon = styled(SvgComponent).withConfig({
  displayName: "Moon__SvgMoon",
  componentId: "sc-h9tigt-0"
})(["", " ", ""], size, color);
export default SvgMoon;